import { ExternalLink } from "lucide-react";
import { dailyDevo } from "@/data/brand";

export const AttributionLink = ({ className = "" }) => (
  <div className={`flex items-center justify-center gap-2 text-center text-sm text-[#4A5D4E] ${className}`} data-testid="dailydevo-attribution-text">
    <img
      src={dailyDevo.logoUrl}
      alt="DailyDevo logo"
      className="h-8 w-8 rounded-full object-cover shadow-[0_4px_14px_rgba(26,54,38,0.10)]"
      data-testid="dailydevo-attribution-logo"
    />
    <span>Created by</span>
    <a
      href={dailyDevo.url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 font-semibold text-[#1A3626] underline decoration-[#C87961]/50 underline-offset-4 transition-colors duration-300 hover:text-[#C87961]"
      data-testid="dailydevo-attribution-link"
    >
      {dailyDevo.name}
      <ExternalLink size={13} aria-hidden="true" />
    </a>
  </div>
);